import LegalLayout, { LegalH2, LegalP, LegalUL } from "@/components/LegalLayout";

export default function AvisoLegal() {
    return (
        <LegalLayout eyebrow="Legal" title="Aviso Legal">
            <LegalH2>Titular del sitio web</LegalH2>
            <LegalP>
                En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la
                Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa:
            </LegalP>
            <LegalUL>
                <li>Titular: Santiago Lorenzo Garrido</li>
                <li>NIF: 34986749T</li>
                <li>Domicilio: Calle Méjico 4, 24193 Navatejera (León), España</li>
                <li>Email: santilorenzo@desactivaelpatron.com</li>
                <li>Teléfono / WhatsApp: +34 605 045 728</li>
                <li>
                    Actividad: servicios de mentoría y acompañamiento en desarrollo
                    personal y profesional, formación online y conferencias.
                </li>
            </LegalUL>

            <LegalH2>Objeto</LegalH2>
            <LegalP>
                Este sitio web (desactivaelpatron.com) ofrece información sobre los
                servicios de Santi Lorenzo y el Método SIRCS: mentorías grupales, sesiones
                privadas, formaciones, contenidos gratuitos y conferencias.
            </LegalP>

            <LegalH2>Naturaleza de los servicios</LegalH2>
            <LegalP>
                Los servicios ofrecidos son de desarrollo personal y acompañamiento. No
                constituyen tratamiento sanitario, psicológico ni médico, ni sustituyen la
                atención de un profesional sanitario. Si atraviesas un problema de salud
                mental, consulta con un profesional sanitario.
            </LegalP>

            <LegalH2>Condiciones de uso</LegalH2>
            <LegalP>
                El acceso al sitio es gratuito y atribuye la condición de usuario, que se
                compromete a hacer un uso lícito del mismo y de sus contenidos, sin dañar
                la imagen, los intereses o los derechos del titular o de terceros.
            </LegalP>

            <LegalH2>Propiedad intelectual e industrial</LegalH2>
            <LegalP>
                Todos los contenidos de este sitio (textos, imágenes, audios, vídeos,
                logotipos, la marca y el Método SIRCS™, así como su diseño) son propiedad
                del titular o se usan con licencia. Queda prohibida su reproducción,
                distribución, comunicación pública o transformación sin autorización
                expresa por escrito.
            </LegalP>

            <LegalH2>Responsabilidad</LegalH2>
            <LegalP>
                El titular no se hace responsable de interrupciones del servicio, errores
                técnicos o del uso que terceros hagan de la información publicada. Los
                resultados de los procesos de transformación personal dependen del
                compromiso y las circunstancias de cada persona y no se garantizan.
            </LegalP>

            <LegalH2>Enlaces</LegalH2>
            <LegalP>
                Este sitio contiene enlaces a plataformas de terceros (Hotmart, Calendly,
                WhatsApp, Instagram, YouTube, TikTok, Skool…). El titular no se
                responsabiliza de sus contenidos ni de sus políticas.
            </LegalP>

            <LegalH2>Ley aplicable y jurisdicción</LegalH2>
            <LegalP>
                Se rige por la legislación española. Para cualquier controversia, las
                partes se someten a los juzgados y tribunales que correspondan conforme a
                la normativa de consumidores y usuarios.
            </LegalP>
        </LegalLayout>
    );
}
